var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoTransparent = function SvgLogoTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1122.52 793.701"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 595.276h841.89V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 12.23-12.23L43.432 9.845l35.427 35.427-21.357 21.357-35.427-35.427Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 167.178 367.006)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 793.701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.833-5.833-5.734-15.394.226-21.351 5.954-5.957 15.518-6.056 21.348-.226 5.83 5.833 5.727 15.387-.23 21.344C15.384 5.724 5.83 5.83 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(104.276 308.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 12.23 12.23-22.075 31.202-35.427 35.427-21.357-21.357 35.427-35.427Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(187.557 212.898)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.833-5.83 15.394-5.731 21.351.226 5.957 5.954 6.053 15.518.223 21.348-5.83 5.833-15.384 5.731-21.341-.23C-5.724 15.387-5.83 5.833 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(198.924 191.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.23 12.23-31.202-22.075-35.427-35.424 21.357-21.36 35.427 35.43z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(294.426 275.253)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c5.83 5.83 5.731 15.39-.226 21.348-5.954 5.96-15.518 6.056-21.348.226-5.83-5.83-5.728-15.387.229-21.344C-15.387-5.728-5.833-5.833 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(315.534 286.623)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-12.23-12.23L9.845-43.432l35.427-35.427 21.357 21.36-35.427 35.424z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(232.253 382.376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.83 5.83-15.394 5.734-21.351-.223-5.957-5.957-6.053-15.521-.223-21.351 5.833-5.833 15.387-5.728 21.341.233C5.724-15.384 5.833-5.83 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(220.885 403.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-101.269h-22.18V0h-36.107v20.633h94.39V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(400.101 350.956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-15.132 0-23.041-10.833-23.041-25.277v-45.045h-21.663v89.405h18.222l1.894-13.413C-20.464 15.99-9.803 20.286.686 20.286c2.235 0 4.471-.173 6.706-.517V-.864C4.984-.344 2.405 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(475.07 320.009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-22.697-1.722C-29.228-2.236-35.59-6.19-35.59-13.41c0-6.879 6.018-11.178 12.724-11.178C-9.456-24.588 0-17.365 0-4.13zm18.053-41.094c-9.283 0-14.443 5.845-15.132 12.552-4.123-7.223-14.44-13.41-27.161-13.41-21.322 0-32.324 13.41-32.324 28.025 0 17.02 13.237 26.82 30.257 28.026L0 15.99v5.498c0 8.425-2.921 14.099-15.132 14.099-9.972 0-15.815-4.468-16.331-12.721h-20.803c1.203 20.116 17.189 29.055 37.134 29.055 15.304 0 28.37-4.815 33.53-18.225 2.235-5.674 2.576-12.033 2.576-18.051V-17.54c0-4.127 1.375-5.673 4.988-5.673 1.371 0 2.752.344 2.752.344v-15.818c-3.613-1.546-5.504-2.407-10.661-2.407",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(542.64 289.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.911 339.093h21.836v-89.405h-21.836zm-.689 34.554h23.041V351.47h-23.041z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-14.612 0-24.412 7.051-24.412 24.071V125.34h21.663V27.684c0-5.163 1.202-8.601 8.594-8.601 1.895 0 2.411.176 3.614.176V1.205C5.16.344 4.302 0 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(650.107 248.654)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-7.223-7.22-18.398-10.313-30.605-10.313-11.344 0-21.488 3.265-28.881 10.313-5.16 4.984-9.455 12.38-9.455 20.805h20.113c0-3.957 2.064-8.25 4.812-10.492 3.438-2.745 7.396-3.951 13.586-3.951 7.22 0 18.222 1.547 18.222 11.35 0 5.157-3.438 8.598-8.939 9.456-7.909 1.202-16.848 1.719-24.76 3.437-12.207 2.58-20.458 12.549-20.458 23.899 0 9.112 3.783 15.47 9.112 20.114 6.534 5.676 15.993 8.942 27.164 8.942 10.661 0 21.494-3.438 28.029-10.489 4.812-5.157 7.906-11.863 7.906-18.394h-20.461c0 3.437-1.544 6.186-3.611 8.422-2.573 2.583-7.22 4.126-11.691 4.126-3.093 0-6.017 0-9.283-1.377-3.782-1.544-6.876-4.809-6.876-9.453 0-6.362 5.498-8.253 10.317-8.942 8.078-1.03 10.313-1.202 19.083-2.58C-2.58 42.641 7.74 33.699 7.74 19.6 7.74 11.005 4.643 4.643 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(734.184 257.766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.036 1.113-2.625 1.741-4.139 1.741-1.515 0-3.107-.628-4.143-1.741-1.811-1.885-1.885-5.134-1.885-7.539 0-2.405.074-5.619 1.885-7.504 1.036-1.11 2.628-1.741 4.143-1.741 1.514 0 3.103.631 4.139 1.741 1.811 1.885 1.885 5.099 1.885 7.504C1.885-5.134 1.811-1.885 0 0m3.399-18.149c-1.996-1.996-4.729-2.956-7.538-2.956-2.81 0-5.546.96-7.543 2.956-2.848 2.845-3.329 6.321-3.329 10.61 0 4.286.481 7.797 3.329 10.648 1.997 1.993 4.733 2.953 7.543 2.953 2.809 0 5.542-.96 7.538-2.953C6.247.258 6.729-3.253 6.729-7.539c0-4.289-.482-7.765-3.33-10.61",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(391.786 224.24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-7.022h11.902v-4.328H0v-10.533h-4.771V4.324h18.117V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(408.728 225.499)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-5.249l-8.687 26.211h5.064l6.359-20.002 6.321 20.002h4.806z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(452.897 203.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.979 237.33h4.324v-4.471h-4.324zm-1.665-13.346-3.734-11.053h7.465zm-5.954 13.346h4.324v-4.471h-4.324zm12.868-33.715-1.703 5.026H468.1l-1.7-5.026h-4.806l9.204 26.208h5.214l9.204-26.208z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.996-1.993-5.064-2.806-8.282-2.806-2.771 0-5.693.739-7.836 2.697-1.553 1.404-2.736 3.623-2.736 6.098h4.879c0-1.292.594-2.44 1.369-3.215 1.109-1.109 2.882-1.406 4.4-1.406 1.812 0 3.55.37 4.548 1.406.59.625 1.033 1.257 1.033 2.513 0 1.923-1.479 2.813-3.106 3.107-1.773.331-4.066.408-5.804.704-3.62.587-6.652 2.953-6.652 7.316 0 2.073.921 3.811 2.289 5.179 1.742 1.7 4.621 2.771 7.692 2.771 2.81 0 5.546-.886 7.319-2.551 1.55-1.48 2.625-3.403 2.66-5.581h-4.879c-.035.922-.517 1.92-1.145 2.587-.852.886-2.59 1.406-3.993 1.406-1.48 0-3.179-.335-4.251-1.441-.555-.594-.886-1.26-.886-2.22 0-1.703 1.106-2.586 2.662-2.848 1.662-.258 3.99-.443 5.693-.663 3.916-.558 7.207-3.106 7.207-7.577C2.181 3.033 1.295 1.295 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(505.262 205.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-21.775h-4.771V0h-7.762v4.436H7.765V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(522.611 225.39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v18.707L-6.802.37h-3.511l-6.764 18.56V0h-4.625v26.211h6.433l6.875-18.672 6.914 18.672h6.101V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(556.926 203.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.734-11.057h7.468zm6.911-20.372-1.7 5.026H-5.214l-1.7-5.026h-4.806l9.204 26.211h5.214l9.204-26.211z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(577.717 223.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.35 18.005V0h-4.691v26.211h5.064L.223 8.464v17.747h4.694V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(609.184 203.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v26.211h4.768V4.509h12.166V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(621.063 203.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-3.734-11.057h7.468zm6.914-20.372-1.7 5.026H-5.214l-1.7-5.026h-4.806l9.207 26.211h5.211l9.204-26.211z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(650.683 223.985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-11.35 18.005V0h-4.694v26.211h5.067L.22 8.464v17.747h4.698V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(682.337 203.614)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.883.887-2.181 1.48-3.693 1.48H-9.13v-17.636h5.437c1.512 0 2.81.59 3.693 1.477 1.85 1.853 1.888 4.956 1.888 7.36C1.888-4.918 1.85-1.846 0 0m3.661-17.632c-1.735-1.815-4.363-2.81-7.354-2.81h-10.205V5.769h10.205c2.991 0 5.619-.998 7.354-2.81C6.359.185 6.729-3.696 6.729-7.319c0-3.626-.37-7.539-3.068-10.313",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(708.298 224.057)"
  })));
};
export { SvgLogoTransparent as ReactComponent };
export default __webpack_public_path__ + "static/logo-transparent.f8c108dd.svg";